import { createRoot } from 'react-dom/client';
import MappaStrutture from './components/MappaStrutture';

const containerId = 'map-wrapper-7d815a3c-eb92-4bdc-920e-49486017c5ed';

document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById(containerId);
    if (!el) return;

    const dataUrl = el.dataset.sportelliJson;
    const geoJsonUrl = el.dataset.geojson;
    const capDataUrl = el.dataset.capJson || el.dataset.capDataUrl || el.dataset.capJsonUrl;
    const title = el.dataset.title;

    createRoot(el).render( 
        <MappaStrutture
            dataUrl={dataUrl}
            geoJsonUrl={geoJsonUrl} 
            capDataUrl={capDataUrl}
            title={title}
        />
    );
});
